import React from "react";
import { Helmet } from "react-helmet-async";

export default function StaticContentPage({
  title,
  description,
  canonical,
  eyebrow,
  heading,
  intro,
  sections,
}) {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
      </Helmet>

      <div className="w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="space-y-10">
          <header className="space-y-4 border-b border-gray-800/50 pb-8">
            {eyebrow ? (
              <p className="text-sm font-bold tracking-[0.08em] text-indigo-400">{eyebrow}</p>
            ) : null}
            <h1 className="text-4xl font-black tracking-tighter text-white sm:text-5xl">{heading}</h1>
            <p className="max-w-3xl text-base leading-7 text-gray-400 sm:text-lg">{intro}</p>
          </header>

          <div className="space-y-8">
            {sections.map((section) => (
              <section
                key={section.title}
                className="rounded-2xl border border-gray-800/50 bg-gray-900/40 p-6 backdrop-blur-sm sm:p-8"
              >
                <div className="space-y-4">
                  <h2 className="text-2xl font-black tracking-tight text-white">{section.title}</h2>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph} className="text-sm leading-7 text-gray-400 sm:text-base">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
